module.exports = __webpack_public_path__ + "img/12-min.2958d264.jpg";